// ActionButton.tsx
import React from "react";

interface ActionButtonProps {
  tradeDirection: "Buy" | "Sell";
  isEditable: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({ tradeDirection, isEditable }) => {
  const buttonText = isEditable
    ? tradeDirection === "Buy"
      ? "Modify Buy Order"
      : "Modify Sell Order"
    : tradeDirection === "Buy"
    ? "Buy"
    : "Sell";

  return (
    <button
      type="submit"
      className={`btn-alert border-0 ${
        tradeDirection === "Buy" ? "btn tv-btn-success" : "btn tv-btn-danger"
      }`}
    >
      {buttonText}
    </button>
  );
};

export default ActionButton;
